const validator = {
  /**
   * Valida se um valor é do tipo Celular
   * @param  {String} value [description]
   * @param  {Object} args  [description]
   * @return {Boolean}      Retorna se o campo é valido
   */
  validate (value, args) {
    const regex = /^(?:(55\d{2})|\d{2})[6-9]\d{8}$/
    return regex.test(value)
  }
}

export default validator
